import React from 'react';
import { GiftIcon } from 'lucide-react';
import { BONUS_VALUE, bonuses } from '../data/content';
import { BONUS_SIZES, BONUS_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
import { Accent, SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
export function BonusesSection() {
  return <section className="w-full border-y border-white/5 bg-steel-900 px-6 py-16 sm:py-20" aria-labelledby="bonuses-title" data-id="element-13" data-mp="qt0a0fzspi4d">
      <div className="mx-auto max-w-6xl" data-id="element-14" data-mp="14rhr3uv73wdb">
        <SectionHeading id="bonuses-title" badge="The Instructor Advantage" badgeIcon={GiftIcon} title={<>
              6 high-value bonuses, <Accent data-id="element-16" data-mp="1ei2q3jes72wr">yours at zero cost</Accent>
            </>} subtitle={`Secure the IIIS 2026 today and these six specialized pedagogical tools — a ${BONUS_VALUE} value — come included.`} data-id="element-15" data-mp="zv15b7bgxu3e" />

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-17" data-mp="1nkvffh4el4jy">
          {bonuses.map(({
          number,
          title,
          description,
          value,
          image
        }, index) => <Reveal as="li" key={number} index={index} className="h-full" data-id="element-18" data-mp="3prn53ys4db3b" data-mpi={index}>
              <div className="flex h-full flex-col border border-white/[0.07] bg-steel-850 p-5 transition-[transform,border-color] duration-150 ease-out hover:-translate-y-1 hover:border-ember-500/50" data-id="element-19" data-mp="3trduby1zzj5q">
                <div className="relative flex items-center justify-center bg-steel-950 py-5" data-id="element-20" data-mp="7kz1kdcpwvzr">
                  <img src={optimizedImage(image, 320)} srcSet={optimizedSrcSet(image, BONUS_WIDTHS)} sizes={BONUS_SIZES} alt={`Cover of bonus ${number}: ${title}`} width={1248} height={1248} loading="lazy" decoding="async" className="w-3/4 shadow-cover" data-id="element-21" data-mp="ckbkwo4drkxl" />
                  <span className="absolute right-3 top-3 bg-ember-500 px-2 py-1 font-display text-[0.65rem] font-bold uppercase tracking-[0.14em] text-steel-950" data-id="element-22" data-mp="le6s01p2blfv">
                    Free
                  </span>
                </div>
                <div className="mt-5 flex items-baseline justify-between gap-3" data-id="element-23" data-mp="108uur832w5rs">
                  <p className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-ember-400" data-id="element-24" data-mp="al8pd54cm9hh">
                    Bonus {number}
                  </p>
                  <p className="text-xs text-ink-500" data-id="element-25" data-mp="5nyzjod1rvt4">
                    <span className="line-through" data-id="element-26" data-mp="kbab3q98bft8">${value}</span> value
                  </p>
                </div>
                <h3 className="mt-1 font-display text-xl font-semibold uppercase leading-tight tracking-wide text-ink-50" data-id="element-27" data-mp="fjafub43tb2z">
                  {title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-400" data-id="element-28" data-mp="ocvtfr4j8mat">{description}</p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal className="mt-6 flex flex-col items-center justify-between gap-4 border border-ember-500/30 bg-ember-500/[0.06] px-7 py-6 sm:flex-row" data-id="element-29" data-mp="139e85mbudoeo">
          <p className="font-display text-2xl font-semibold uppercase tracking-wide text-ink-50" data-id="element-30" data-mp="350zodyuaatjt">
            Total bonus value <span className="text-ember-400" data-id="element-31" data-mp="302y7nkkbz6bi">${BONUS_VALUE}</span>
          </p>
          <p className="text-sm text-ink-400" data-id="element-32" data-mp="1fkdxq25yv532">Included free with the IIIS 2026 core system.</p>
        </Reveal>
      </div>
    </section>;
}